export const alignmentModes = () => [
    { label: 'Anterior Pelvic Plane', value: 'APP' },
    { label: 'CT Scanner Coordinates', value: 'none' },
    { label: 'Functional Pelvic Plane', value: 'FPP' },
];
